"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Tick = function Tick(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M29.049 5.009l-.859-.858a2.434 2.434 0 0 0-3.434 0L10.172 18.737l-5.175-5.173a2.433 2.433 0 0 0-3.432.001l-.858.857a2.437 2.437 0 0 0 0 3.433l7.744 7.752a2.437 2.437 0 0 0 3.433 0L29.049 8.442a2.438 2.438 0 0 0 0-3.433z",
    "'data-original'": "#010002",
    className: "active-path",
    "'data-old_color'": "#FFFFFF"
  }));
};

Tick.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 29.756 29.756",
  width: "512",
  height: "512"
};

var DoneTick = function DoneTick(_ref) {
  var classes = _ref.classes;
  return _react["default"].createElement("div", {
    className: classes.icon
  }, _react["default"].createElement(Tick, {
    className: classes.tick
  }));
};

DoneTick.propTypes = {
  classes: _propTypes.any // eslint-disable-line react/forbid-prop-types

};
var _default = DoneTick;
exports["default"] = _default;